import React from "react";
import styles from "./ContactInfo.module.less";
import { FormattedMessage } from "react-intl";
import PhoneLink from "../PhoneLink";
const ContactInfo = () => (<p>
		<span className={styles.name}>
			<FormattedMessage id="contactInfo.name" defaultMessage="DCM Services LLC"/>
		</span>
		{" "}
		<PhoneLink />
	</p>);
export default ContactInfo;



// WEBPACK FOOTER //
// ./src/assets/scripts/components/presentational/ContactInfo/ContactInfo.tsx